import { HOME_CIRCLES_HIGHLIGHTS } from "../../data/homeCirclesHighlights";
import SectionViewAllLink from "./SectionViewAllLink";

const HomeCirclesSection = ({ Reveal }) => (
  <section
    id="circles"
    data-testid="community-section"
    className="relative py-28 md:py-36 scroll-mt-28"
    style={{ background: "var(--bg-alt)" }}
  >
    <div className="paper-overlay absolute inset-0 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="text-center md:text-left max-w-2xl mx-auto md:mx-0">
            <span
              className="inline-block text-[11px] uppercase tracking-[0.25em] font-semibold mb-4"
              style={{ color: "var(--brand)" }}
            >
              A warm community
            </span>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]"
              style={{ color: "var(--text)" }}
            >
              Reading is better{" "}
              <span className="italic" style={{ color: "var(--brand)" }}>
                together
              </span>
            </h2>
          </div>
          <SectionViewAllLink
            to="/circles"
            label="Browse all circles"
            testId="circles-view-all-btn"
            className="hidden md:inline-flex shrink-0 mx-auto md:mx-0"
          />
        </div>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-6">
        {HOME_CIRCLES_HIGHLIGHTS.map((item, i) => {
          const Icon = item.icon;
          return (
            <Reveal key={item.title} delay={i * 0.08}>
              <div
                data-testid={`community-card-${i}`}
                className="cozy-card rounded-3xl p-8 h-full flex flex-col"
              >
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6"
                  style={{ background: "var(--brand-tint)" }}
                >
                  <Icon className="w-6 h-6" style={{ color: "var(--brand)" }} />
                </div>
                <h3
                  className="font-serif text-2xl md:text-3xl font-medium mb-3"
                  style={{ color: "var(--text)" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-base leading-relaxed flex-1"
                  style={{ color: "var(--text-soft)" }}
                >
                  {item.desc}
                </p>
                <div
                  className="mt-6 pt-6 border-t flex items-baseline gap-2"
                  style={{ borderColor: "var(--border-soft)" }}
                >
                  <span
                    className="font-serif text-3xl font-semibold italic"
                    style={{ color: "var(--brand)" }}
                  >
                    {item.metric}
                  </span>
                  <span className="text-sm" style={{ color: "var(--text-soft)" }}>
                    {item.metricLabel}
                  </span>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal className="mt-10 flex justify-center md:hidden">
        <SectionViewAllLink
          to="/circles"
          label="Browse all circles"
          testId="circles-view-all-btn-mobile"
        />
      </Reveal>
    </div>
  </section>
);

export default HomeCirclesSection;
